/** @file Tabs: a row of tab buttons (screens, Projects/Trash); the caller renders the active body. */
import type { ReactElement } from 'react';

/** One tab: its id and label. */
export type TabItem<T extends string> = { id: T; label: string };

/** The tabs, the active id and the select callback. */
export type TabsProps<T extends string> = { tabs: TabItem<T>[]; active: T; onSelect: (id: T) => void; label?: string };

/** A `role="tablist"` of buttons; the active one has `aria-selected`. */
export function Tabs<T extends string>({ tabs, active, onSelect, label }: TabsProps<T>): ReactElement {
  return (
    <div className="p3-tabs" role="tablist" aria-label={label}>
      {tabs.map((t) => (
        <button key={t.id} type="button" role="tab" className="p3-tab" aria-selected={t.id === active}
          onClick={() => { onSelect(t.id); }}>
          {t.label}
        </button>
      ))}
    </div>
  );
}
